import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useWhatsAppEmailPrompt } from "@/hooks/useWhatsAppEmailPrompt";
import { Loader2 } from "lucide-react";

interface WhatsAppEmailGateProps {
  children: React.ReactNode;
  mode?: "hard" | "soft";
}

export function WhatsAppEmailGate({
  children,
  mode = "hard",
}: WhatsAppEmailGateProps) {
  const { shouldShow, isChecking } = useWhatsAppEmailPrompt();
  const { user } = useAuth();

  if (isChecking) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (shouldShow) {
    if (mode === "soft") {
      // Soft mode: render children normally (banner + tab interception handle prompting)
      return <>{children}</>;
    }

    // Hard mode: send them to the full verification page's add-email step
    return (
      <Navigate
        to="/verify-email"
        replace
        state={{ email: user?.email, flow: "whatsapp-first" }}
      />
    );
  }

  return <>{children}</>;
}
